(() => {
  if (!window.__dx) return;
  const { root, cfg, R, RM, FINE, $, $$, esc, tee, T } = window.__dx;
  const LANG = document.documentElement.lang || 'en';
  // Strings added with the colour picker; merged into this page's dictionary.
  const XK = ["The Lead Never Follow Leaders raglan tee. White body, sleeves in black, blue or red.", "White body, contrast raglan sleeves, bold black front print.", "White body.\nPick your sleeves.", "Black, blue or red. Sizes S to XXL.", "Sleeves", "Black", "Blue", "Red"];
  const XV = {"cs": ["Triko Lead Never Follow Leaders s raglánovými rukávy. Bílé tělo, rukávy černé, modré nebo červené.", "Bílé tělo, kontrastní raglánové rukávy, výrazný černý potisk vpředu.", "Bílé tělo.\nVyber si rukávy.", "Černé, modré nebo červené. Velikosti S až XXL.", "Rukávy", "Černá", "Modrá", "Červená"], "de": ["Das Lead Never Follow Leaders Raglan-Shirt. Weißer Körper, Ärmel in Schwarz, Blau oder Rot.", "Weißer Körper, kontrastfarbene Raglanärmel, großer schwarzer Frontprint.", "Weißer Körper.\nWähl deine Ärmel.", "Schwarz, Blau oder Rot. Größen S bis XXL.", "Ärmel", "Schwarz", "Blau", "Rot"], "fr": ["Le t-shirt raglan Lead Never Follow Leaders. Corps blanc, manches noires, bleues ou rouges.", "Corps blanc, manches raglan contrastées, grand imprimé noir devant.", "Corps blanc.\nChoisis tes manches.", "Noir, bleu ou rouge. Tailles S à XXL.", "Manches", "Noir", "Bleu", "Rouge"], "es": ["La camiseta raglán Lead Never Follow Leaders. Cuerpo blanco, mangas negras, azules o rojas.", "Cuerpo blanco, mangas raglán en contraste, gran estampado negro delante.", "Cuerpo blanco.\nElige tus mangas.", "Negro, azul o rojo. Tallas S a XXL.", "Mangas", "Negro", "Azul", "Rojo"], "it": ["La t-shirt raglan Lead Never Follow Leaders. Corpo bianco, maniche nere, blu o rosse.", "Corpo bianco, maniche raglan a contrasto, grande stampa nera davanti.", "Corpo bianco.\nScegli le maniche.", "Nero, blu o rosso. Taglie dalla S alla XXL.", "Maniche", "Nero", "Blu", "Rosso"], "pl": ["Koszulka raglan Lead Never Follow Leaders. Biały korpus, rękawy czarne, niebieskie lub czerwone.", "Biały korpus, kontrastowe rękawy raglanowe, duży czarny nadruk z przodu.", "Biały korpus.\nWybierz rękawy.", "Czarne, niebieskie lub czerwone. Rozmiary od S do XXL.", "Rękawy", "Czarny", "Niebieski", "Czerwony"]}[LANG.slice(0, 2)];
  if (XV && window.__dxDict) XK.forEach((k, i) => { window.__dxDict[k] = XV[i]; });
  // ---------- Buy form, AJAX add, sticky bar, toast ----------
  const form = $('[data-buy-form]');
  const sticky = $('[data-sticky]');
  const toastEl = $('[data-toast]');
  // Variant = colour (option 1, if any) + size (last option); the chosen id lives in a hidden input.
  const vid = form && $('[data-vid]', form);
  const multi = cfg.variants.some((v) => v.o2);
  const chosen = (n) => { const r = form && $$(`input[name="${n}"]`, form).find((x) => x.checked); return r ? r.value : null; };
  const findV = (c, s) => cfg.variants.find((v) => (multi ? v.o1 === c && v.o2 === s : v.o1 === s));
  const selectedId = () => (vid ? vid.value : null);
  const variantBySize = (s) => findV(chosen('dx-color'), s);
  const syncSticky = () => { const s = sticky && $('select', sticky); if (s && selectedId()) s.value = selectedId(); };
  const showImg = (v) => {
    const g = $('.dx-gallery'); const el = g && v && v.img ? g.children[v.img - 1] : null;
    if (el) g.scrollTo({ left: el.offsetLeft - g.offsetLeft, behavior: RM ? 'auto' : 'smooth' });
  };
  const syncSizes = () => {
    if (!form) return;
    $$('input[name="dx-size"]', form).forEach((r) => {
      const v = variantBySize(r.value); const out = !v || !v.available;
      r.disabled = out; r.closest('.dx-size').classList.toggle('is-out', out);
    });
  };
  const fromInputs = () => {
    syncSizes();
    const v = findV(chosen('dx-color'), chosen('dx-size'));
    if (v && vid) { vid.value = v.id; showImg(v); }
    syncSticky();
  };
  const selectVariant = (id) => {
    const v = cfg.variants.find((x) => String(x.id) === String(id));
    if (!v || !form) return;
    $$('input[name="dx-color"]', form).forEach((r) => { r.checked = r.value === v.o1; });
    $$('input[name="dx-size"]', form).forEach((r) => { r.checked = r.value === (multi ? v.o2 : v.o1); });
    if (vid) vid.value = v.id;
    syncSizes(); showImg(v); syncSticky();
  };

  // ---------- Terms checkbox: must be ticked before buying ----------
  const AG = {"cs": ["Souhlasím s {t}obchodními podmínkami{/t} a {r}zásadami vrácení{/r}.", "Pro pokračování zaškrtni souhlas."], "de": ["Ich stimme den {t}AGB{/t} und der {r}Rückgaberichtlinie{/r} zu.", "Bitte setze das Häkchen, um fortzufahren."], "fr": ["J'accepte les {t}conditions générales{/t} et la {r}politique de remboursement{/r}.", "Coche la case pour continuer."], "es": ["Acepto los {t}términos y condiciones{/t} y la {r}política de reembolso{/r}.", "Marca la casilla para continuar."], "it": ["Accetto i {t}termini e condizioni{/t} e la {r}politica di rimborso{/r}.", "Spunta la casella per continuare."], "pl": ["Akceptuję {t}regulamin{/t} i {r}politykę zwrotów{/r}.", "Zaznacz pole, aby kontynuować."]}[LANG.slice(0, 2)] || [];
  const TA = (s, i) => AG[i] || T(s);
  const agree = form && $('[data-agree]', form);
  const agreeBox = agree && agree.closest('.dx-agree');
  if (agree) {
    const link = (h, t) => `<a href="${esc(h)}" target="_blank" rel="noopener">${t}</a>`;
    $('span', agreeBox).innerHTML = TA('I agree to the {t}Terms{/t} and {r}Refund Policy{/r}.', 0)
      .replace(/\{t\}(.*?)\{\/t\}/, (m, x) => link(agree.dataset.terms, x))
      .replace(/\{r\}(.*?)\{\/r\}/, (m, x) => link(agree.dataset.refund, x));
    const sync = () => { form.classList.toggle('is-agreed', agree.checked); if (agree.checked) agreeBox.classList.remove('is-warn'); };
    agree.addEventListener('change', sync);
    sync();
    const ex = $('.dx-express', form);
    if (ex) ex.addEventListener('click', () => { if (!agree.checked) agreed(); });
  }
  function agreed() {
    if (!agree || agree.checked) return true;
    agreeBox.classList.add('is-warn');
    agreeBox.setAttribute('data-hint', TA('Please tick the box to continue.', 1));
    agreeBox.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' });
    agree.focus({ preventScroll: true });
    return false;
  }

  let toastTimer;
  function showToast(id, count) {
    const v = cfg.variants.find((x) => String(x.id) === String(id));
    toastEl.innerHTML = `<button type="button" class="dx-toast__x" aria-label="Close">&times;</button>
      <p><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M4 12l5 5L20 6"/></svg>${T('Added to bag')}</p>
      <small>${esc(cfg.title)}${v ? ` &middot; ${T('Size')} ${esc(v.title)}` : ''}</small>
      <div class="dx-toast__row"><a class="dx-btn dx-btn--ghost" href="${R}cart">${T('Bag')} (${count})</a><a class="dx-btn dx-btn--light" href="${R}checkout">${T('Checkout')}</a></div>`;
    toastEl.classList.add('is-on');
    $('.dx-toast__x', toastEl).addEventListener('click', () => toastEl.classList.remove('is-on'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-on'), 7000);
  }

  async function addToBag(id, btn) {
    if (!id || !agreed()) return;
    btn.classList.add('is-loading');
    try {
      if (cfg.demo) { await new Promise((r) => setTimeout(r, 500)); showToast(id, 1); return; }
      const res = await fetch(`${R}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('add failed');
      const cart = await (await fetch(`${R}cart.js`)).json();
      showToast(id, cart.item_count);
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'drop-x', data: { itemCount: cart.item_count, source: 'drop-x' } } }));
    } catch (err) {
      if (form) form.submit();
    } finally {
      btn.classList.remove('is-loading');
    }
  }

  const buyNow = (id, btn) => {
    if (!id || !agreed()) return;
    if (btn) btn.classList.add('is-loading');
    if (cfg.demo) { setTimeout(() => btn && btn.classList.remove('is-loading'), 600); return; }
    location.href = `${R}cart/${id}:1`;
  };
  addEventListener('pageshow', () => $$('.is-loading').forEach((b) => b.classList.remove('is-loading')));

  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const sub = e.submitter || $('[data-buy-now]', form);
      if (sub && sub.hasAttribute('data-buy-now')) buyNow(selectedId(), sub);
      else addToBag(selectedId(), sub);
    });
    const addBtn = $('[data-add]', form);
    if (addBtn) addBtn.addEventListener('click', (e) => addToBag(selectedId(), e.currentTarget));
    form.addEventListener('change', (e) => { if (/^dx-(color|size)$/.test(e.target.name)) fromInputs(); });
    syncSizes();
    const sg = $('[data-open-fit]', form);
    if (sg) sg.addEventListener('click', () => $('#dx-fit').scrollIntoView({ behavior: RM ? 'auto' : 'smooth' }));
  }

  if (sticky && form && cfg.variants.length) {
    sticky.innerHTML = `<div class="dx-sticky__t"><b>${esc(cfg.title)}</b><span>${esc(cfg.price)}</span></div>
      <label class="dx-vh" for="dx-sticky-size">${T('Size')}</label>
      <select id="dx-sticky-size">${cfg.variants.map((v) => `<option value="${v.id}"${v.available ? '' : ' disabled'}>${esc(v.title)}</option>`).join('')}</select>
      <button class="dx-btn dx-btn--dark" type="button">${T('Buy now')}</button>`;
    const sel = $('select', sticky);
    sel.addEventListener('change', () => selectVariant(sel.value));
    $('button', sticky).addEventListener('click', (e) => buyNow(sel.value, e.currentTarget));
    syncSticky();
    new IntersectionObserver(([e]) => {
      sticky.classList.toggle('is-on', !e.isIntersecting);
    }).observe(form);
  }

  // ---------- Anatomy hotspots ----------
  const an = $('[data-anatomy]');
  if (an) {
    const pts = cfg.anatomy;
    const stage = $('.dx-anat__stage', an);
    const list = $('.dx-anat__list', an);
    stage.innerHTML = tee('front') + pts.map((p, i) => `<button type="button" class="dx-hs" style="left:${p.x}%;top:${p.y}%" aria-expanded="false" aria-label="${esc(p.t)}" data-i="${i}">${i + 1}</button>`).join('');
    list.innerHTML = pts.map((p, i) => `<li data-i="${i}"><span>0${i + 1}</span><b>${esc(p.t)}</b><p>${esc(p.d)}</p></li>`).join('');
    const activate = (i) => {
      $$('.dx-hs', an).forEach((b) => b.setAttribute('aria-expanded', String(b.dataset.i === i)));
      $$('li', list).forEach((l) => l.classList.toggle('is-active', l.dataset.i === i));
      list.classList.toggle('has-active', i !== null);
    };
    an.addEventListener('click', (e) => { const b = e.target.closest('[data-i]'); if (b) activate(b.dataset.i); });
    if (FINE) $$('[data-i]', an).forEach((b) => b.addEventListener('pointerenter', () => activate(b.dataset.i)));
    an.addEventListener('pointerleave', () => activate(null));
  }

  // ---------- Fit finder ----------
  const fitEl = $('[data-fit]');
  if (fitEl && cfg.sizes.length) {
    const S = cfg.sizes;
    const st = { h: 178, build: 1, fit: 0, tee: NaN };
    fitEl.innerHTML = `<div>
      <div class="dx-field"><label for="dx-h">${T('Height')} <output id="dx-ho">178 cm</output></label>
        <input class="dx-range" id="dx-h" type="range" min="150" max="205" value="178"></div>
      <div class="dx-field"><p>${T('Build')}</p><div class="dx-seg" data-k="build">
        <button type="button" aria-pressed="false" data-v="0">${T('Slim')}</button><button type="button" aria-pressed="true" data-v="1">${T('Average')}</button><button type="button" aria-pressed="false" data-v="2">${T('Broad')}</button></div></div>
      <div class="dx-field"><p>${T('Preferred fit')}</p><div class="dx-seg" data-k="fit">
        <button type="button" aria-pressed="true" data-v="0">${T('True to size')}</button><button type="button" aria-pressed="false" data-v="1">${T('Oversized')}</button></div></div>
      <div class="dx-field"><label for="dx-tee">${T('Pro mode: a tee you love')} <span style="opacity:.5;font-weight:400">${T('optional')}</span></label>
        <div class="dx-num"><input id="dx-tee" type="number" inputmode="decimal" min="35" max="80" placeholder="${T('Chest width, laid flat')}"><span>cm</span></div>
        <p class="dx-hint">${T('Lay a tee that fits you well flat and measure straight across, just below the armpits. This overrides the estimate.')}</p></div>
    </div>
    <div class="dx-result" aria-live="polite">
      <div class="dx-result__top"><div><p class="dx-eyebrow">${T('Your size')}</p><div class="dx-result__size" data-out></div></div><div class="dx-result__meta" data-meta></div></div>
      <div class="dx-bars">${S.map((z) => `<div class="dx-bar" data-s="${esc(z.s)}"><b>${esc(z.s)}</b><div class="dx-bar__track"><div class="dx-bar__fill"></div></div><span>${z.chest} cm</span></div>`).join('')}</div>
      <button class="dx-btn dx-btn--light" type="button" data-pick></button>
      <p class="dx-hint" style="margin-top:14px">${T('A guide based on typical proportions. Not the right fit? You can return it within 14 days.')}</p>
    </div>`;
    const lo = Math.min(...S.map((s) => s.chest)) - 10;
    const hi = Math.max(...S.map((s) => s.chest)) + 6;
    const pct = (v) => `${Math.max(0, Math.min(100, ((v - lo) / (hi - lo)) * 100))}%`;
    const out = $('[data-out]', fitEl), meta = $('[data-meta]', fitEl), pick = $('[data-pick]', fitEl);
    const bars = $$('.dx-bar', fitEl);
    requestAnimationFrame(() => bars.forEach((b, k) => { $('.dx-bar__fill', b).style.width = pct(S[k].chest); }));
    const calc = () => {
      let i;
      if (st.tee >= 35 && st.tee <= 80) {
        const target = st.tee + (st.fit ? 3 : 0);
        i = S.reduce((best, s, k) => (Math.abs(s.chest - target) < Math.abs(S[best].chest - target) ? k : best), 0);
      } else {
        const h = st.h;
        i = h < 165 ? 0 : h < 174 ? 1 : h < 183 ? 2 : h < 192 ? 3 : 4;
        i += st.build - 1 + st.fit;
      }
      return Math.max(0, Math.min(S.length - 1, i));
    };
    let prev = null, touched = false;
    const render = () => {
      const s = S[calc()];
      if (s.s !== prev) { out.classList.remove('bump'); void out.offsetWidth; out.classList.add('bump'); prev = s.s; }
      out.textContent = s.s;
      meta.innerHTML = `${T('Chest')} ${s.chest} cm<br>${T('Length')} ${s.length} cm<br>${T('Sleeve')} ${s.sleeve} cm`;
      bars.forEach((b) => {
        b.classList.toggle('is-rec', b.dataset.s === s.s);
        let you = $('.dx-bar__you', b);
        const valid = st.tee >= 35 && st.tee <= 80;
        if (valid && !you) { you = document.createElement('i'); you.className = 'dx-bar__you'; $('.dx-bar__track', b).appendChild(you); }
        if (you) { if (valid) you.style.left = pct(st.tee); else you.remove(); }
      });
      pick.textContent = `${T('Select size')} ${s.s}`;
      pick.dataset.s = s.s;
      if (touched) $$('.dx-size', root).forEach((l) => l.classList.toggle('is-rec', $('span', l).textContent.trim() === s.s));
    };
    fitEl.addEventListener('input', () => { touched = true; }, true);
    fitEl.addEventListener('click', (e) => { if (e.target.closest('button')) touched = true; }, true);
    $('#dx-h', fitEl).addEventListener('input', (e) => { st.h = Number(e.target.value); $('#dx-ho', fitEl).textContent = `${st.h} cm`; render(); });
    $('#dx-tee', fitEl).addEventListener('input', (e) => { st.tee = parseFloat(e.target.value); render(); });
    $$('.dx-seg', fitEl).forEach((g) => g.addEventListener('click', (e) => {
      const b = e.target.closest('button'); if (!b) return;
      $$('button', g).forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      st[g.dataset.k] = Number(b.dataset.v);
      render();
    }));
    pick.addEventListener('click', () => {
      const v = variantBySize(pick.dataset.s);
      if (v) selectVariant(v.id);
      const target = $('#dx-buy');
      if (target) target.scrollIntoView({ behavior: RM ? 'auto' : 'smooth' });
    });
    render();
  }

  // ---------- Delivery estimate ----------
  const EU = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE'.split(' ');
  const COUNTRIES = [['CZ', 'Czechia'], ['SK', 'Slovakia'], ['DE', 'Germany'], ['AT', 'Austria'], ['PL', 'Poland'], ['FR', 'France'], ['NL', 'Netherlands'], ['IT', 'Italy'], ['ES', 'Spain'], ['EU', 'Other EU country'], ['GB', 'United Kingdom'], ['US', 'United States'], ['CA', 'Canada'], ['XX', 'Rest of the world']];
  const regionOf = (c) => (c === 'GB' ? 'UK' : c === 'US' || c === 'CA' ? 'NA' : EU.includes(c) || c === 'EU' ? 'EU' : 'ROW');
  const addBiz = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6) n -= 1; } return x; };
  const fmt = (d, o) => { try { return d.toLocaleDateString(LANG === 'en' ? 'en-GB' : LANG, o || { day: 'numeric', month: 'short' }); } catch (e) { return d.toLocaleDateString('en-GB', o || { day: 'numeric', month: 'short' }); } };
  let DN = null; try { DN = new Intl.DisplayNames([LANG], { type: 'region' }); } catch (e) { /* no localized names */ }
  const cname = (c, n) => (c === 'EU' || c === 'XX' ? T(n) : (DN && LANG !== 'en' ? DN.of(c) : n));
  const range = (a, b) => (a.getMonth() === b.getMonth() ? `${a.getDate()}&ndash;${fmt(b)}` : `${fmt(a)} &ndash; ${fmt(b)}`);
  let cc = (cfg.country || 'XX').toUpperCase();
  if (!COUNTRIES.some(([c]) => c === cc)) cc = EU.includes(cc) ? 'EU' : 'XX';
  const estimate = (c) => {
    const p = cfg.ship.processing, t = cfg.ship.regions[regionOf(c)];
    const now = new Date();
    return { now, ships: addBiz(now, p[1]), a1: addBiz(now, p[0] + t[0]), a2: addBiz(now, p[1] + t[1]), name: cname(c, (COUNTRIES.find(([k]) => k === c) || [, ''])[1]) };
  };
  const eta = $('[data-eta]');
  const renderEta = () => {
    if (!eta) return;
    const e = estimate(cc);
    eta.hidden = false;
    eta.innerHTML = `<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>
      <span>${T('Estimated delivery')}: <b>${range(e.a1, e.a2)}</b> &middot; ${esc(e.name)}</span>`;
  };
  const ship = $('[data-ship]');
  const renderShip = (replay) => {
    if (!ship) return;
    const e = estimate(cc);
    const tl = $('.dx-tl', ship);
    $('[data-k="order"]', ship).textContent = fmt(e.now, { weekday: 'short', day: 'numeric', month: 'short' });
    $('[data-k="ships"]', ship).textContent = fmt(e.ships, { weekday: 'short', day: 'numeric', month: 'short' });
    $('[data-k="arrive"]', ship).innerHTML = range(e.a1, e.a2);
    $('[data-k="to"]', ship).textContent = e.name;
    if (replay && tl.classList.contains('is-in')) { tl.classList.remove('is-in'); void tl.offsetWidth; tl.classList.add('is-in'); }
  };
  if (ship) {
    const sel = $('select', ship);
    sel.innerHTML = COUNTRIES.map(([c, n]) => `<option value="${c}"${c === cc ? ' selected' : ''}>${esc(cname(c, n))}</option>`).join('');
    sel.addEventListener('change', () => { cc = sel.value; renderShip(true); renderEta(); });
  }
  renderShip(false);
  renderEta();
})();
